import React, { Component } from 'react';

class ClientDisclaimer extends Component {
    render(){
        return <p class="disclaimer">By accessing this report I understand and agree that the myCME Learner information contained herein is the property of Haymarket Medical Education, and it may only be used for fulfilling specific responsibilities related to this individual CME/CE activity. I also agree that unless I secure written permission directly from the myCME Learner, I may not use the myCME Learner information for any marketing, solicitation, or audience generation purposes unless they are directly related to this activity.
        <br /><br />
        <strong>Important Note:</strong> Access to reporting data will expire 6 months from activity expiration.</p>
    }
}

export default ClientDisclaimer;
